import React from 'react';
import Form, { FormContext } from '../../../components/molecules/Form';
import {
  AttachedFilesBaseUploadFormSendTemplate,
  AttachedFilesBaseUploadFormTemplate,
} from '../../../_lib/components/AttachedFilesBase';
import { murmurhash } from '../../../lib/js/hash';
import IForm from '../../../types/IForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import FormInput from '../../../components/molecules/Form/components/FormInput/FormInput';
import FormsRow from '../../../components/molecules/Form/components/FormsRow/FormsRow';

export function AttachedFilesUploadEditForm({ form, onSuccess }: { form: IForm; onSuccess: () => void }) {
  const { t } = useSonTranslation('AttachedFiles');

  return (
    <Form id="attached-file-upload-form" model={form} onSuccess={() => setTimeout(onSuccess, 2000)}>
      <FormContext.Consumer>
        {({ inputs, onChange }) => (
          <>
            <FormsRow>
              <FormInput
                id={`attached-file-${inputs.title.name}`}
                type={inputs.title.type}
                name={inputs.title.name}
                required={inputs.title.required}
                labelTitle={t('form.edit.inputs.title.label')}
                value={inputs.title.value}
                minLength={inputs.title.constraints?.minLength}
                maxLength={inputs.title.constraints?.maxLength}
                onChange={(event: any) => onChange(inputs.title.name, event.target.value)}
              />
            </FormsRow>
            <AttachedFilesBaseUploadFormTemplate
              id={`attached-file-upload-input-${murmurhash(form.url)}`}
              fileSelectButtonLabel={t('form.edit.inputs.fileData.label')}
              dropzoneText={t('form.edit.dropzoneText')}
              headline={t('form.edit.inputs.fileData.additionalLabel')}
              hierarchy={3}
            />
            <AttachedFilesBaseUploadFormSendTemplate
              submitButtonLabel={t('form.edit.button')}
              buttonWrapperModifier="right"
            />
          </>
        )}
      </FormContext.Consumer>
    </Form>
  );
}
